import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDRESSES_HINTS } from 'api/query-keys.ts';
import type { AddressHintRes } from 'api/swagger';
import type { AddressField } from 'types/address.ts';

interface IParams {
  search: string;
  group: AddressField;
  countryIds?: number[];
  isEnabled?: boolean;
}

export const useGetAddressHints = (params: IParams) => {
  const { search, group, countryIds, isEnabled = true } = params;

  return useQuery<AddressHintRes[]>({
    queryKey: [ADDRESSES_HINTS, { search, group }],
    queryFn: async () => {
      const { data } = await http.get<AddressHintRes[]>(`/v1/addresses/hints`, {
        params: {
          limit: 20,
          page: 1,
          'filter[search]': search,
          'filter[group]': group,
          ...(countryIds ? { 'filter[countryIds]': countryIds } : {}),
        },
      });

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: isEnabled,
    staleTime: 10 * 1000,
    cacheTime: 60 * 1000,
  });
};
